var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSquareIn = function SvgIconArrowSquareIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.75A1.75 1.75 0 0 0 5 4.5V9a1 1 0 0 0 2 0V4.75h12.25V17H15a1 1 0 1 0 0 2h4.5a1.75 1.75 0 0 0 1.75-1.75V4.5a1.75 1.75 0 0 0-1.75-1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.214 12.8a1 1 0 0 1 .286.7v5.625a1 1 0 1 1-2 0v-3.21l-5.043 5.042a1 1 0 0 1-1.414-1.414L8.086 14.5H4.875a1 1 0 1 1 0-2h5.628c.272 0 .518.11.697.286z"
  }))));
};
export default SvgIconArrowSquareIn;